import styled from "styled-components";

export const Main = styled.div`
  margin-bottom: 10px;
  padding: 10px;
  border-radius: 20px;
`;

export const Container = styled.div`
  width: 1440px;
  padding: 0 20px;
  margin: 0 auto;
`

export const Header = styled.header`
  margin-bottom: 10px;
  padding: 10px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 40px 0;
`